import { useState, useCallback, useMemo, type ReactNode } from 'react';
import {
  I18nContext,
  getInitialLanguage,
  saveLanguage,
  getTranslations,
  formatString as formatStr,
  getCollectionName as getCollName,
  type Language
} from './index';

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const [lang, setLang] = useState<Language>(getInitialLanguage);

  const setLanguage = useCallback((newLang: Language) => {
    setLang(newLang);
    saveLanguage(newLang);
  }, []);

  const value = useMemo(() => ({
    lang,
    t: getTranslations(lang),
    setLanguage,
    formatString: formatStr,
    getCollectionName: (collectionId: string) => getCollName(lang, collectionId),
  }), [lang, setLanguage]);

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}
